// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m4XU","label":"styles_label__3E2P-"};